import { fun, baseData, getLan } from '../js/common.js'

function getFriendList(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>get-friend-list</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content></content>' +
        '</envelope>';
    return xml;
};
//获得某设备所有已分享好友
function deviceShare(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>get-friends-share-to</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//请求获得子设备列表
function deviceSharec(obj) {
    var xml = {
        "content": {
            "duids": [obj.id],
            "accept-sub-share": 1
        },
        "header": {
            "client": {
                "oem": obj.oem,
            },
            "command": "get-subdev-list",
            "flag": "tdkcloud",
            "seq": 0,
            "session": obj.sessionId,
            "version": "v1.13"
        }
    }
    if (obj.isHs === 3) {
        // xml.content['share-access-duids'] = [];
        // xml.content['dtypes'] = [0];
        xml.header.client['app'] = '';
        xml.header.client['id'] = '';
        xml.header.client['type'] = 3;
        xml.header['user-data'] = '';
    }
    return xml;
};
//按子设备分享
function subdevShare(obj) {
    var xml = {
        "content": {
            "duid": obj.id,
            "memo": obj.name,
            "uuid": obj.accountId - 0,
            "items": obj.item
        },
        "header": {
            "client": {
                "oem": obj.oem
            },
            "command": "share-subdevs",
            "flag": "tdkcloud",
            "session": obj.sessionId
        }
    };
    return xml;
};
//为好友添加设备进行分享
function deviceShareSet(obj) {
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<session>' + obj.sessionId + '</session>' +
    //     '<command>add-device-share</command>' +
    //     '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '<type>1</type>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>' +
    //     '<account-id>' + obj.accountId + '</account-id>' +
    //     '<account>' + obj.account + '</account>' +
    //     '<devices>' +
    //     '<count>1</count>' +
    //     '<item>' +
    //     '<device-id>' + obj.id + '</device-id>' +
    //     '<powers>' + obj.powers + '</powers>' +
    //     '<weekdays>' + obj.weekdays + '</weekdays>' +
    //     '<periods>' + obj.periods + '</periods>' +
    //     '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
    //     '<auth-chans></auth-chans>' +
    //     '</item>' +
    //     '</devices>' +
    //     '</content>' +
    //     '</envelope>';
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>add-friend-share</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '<be-friend>1</be-friend>' + //是否自动建立好友关系，0：否，1：是
        '<friends>' +
        '<count>1</count>' +
        '<item>' +
        '<account-id>' + obj.accountId + '</account-id>' +
        '<account>' + obj.account + '</account>' +
        '<powers>' + obj.powers + '</powers>' +
        '<weekdays>' + obj.weekdays + '</weekdays>' +
        '<periods>' + obj.periods + '</periods>' +
        '</item>' +
        '</friends>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//修改分享给某好友的设备权限和通道
function changePower(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>edit-share-power</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<account-id>' + obj.accountId + '</account-id>' +
        '<account>' + obj.account + '</account>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '<powers>' + obj.powers + '</powers>' +
        '<auth-chans></auth-chans>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//修改设备分享时段
function changeTime(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>edit-share-time</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<account-id>' + obj.accountId + '</account-id>' +
        '<account>' + obj.account + '</account>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '<weekdays>' + obj.weekdays + '</weekdays>' +
        '<periods>' + obj.periods + '</periods>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//为设备取消好友分享
function cancelShareSet(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>cancel-friend-share</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '<friends>' +
        '<count>1</count>' +
        '<item>' +
        '<account-id>' + obj.accountId + '</account-id>' +
        '<account>' + obj.account + '</account>' +
        '</item>' +
        '</friends>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//好友查询
function searchFriend(obj) {
    // var xml = '<?xml version="1.0" encoding="utf-8"?>' +
    //     '<envelope>' +
    //     '<header>' +
    //     '<flag>tdkcloud</flag>' +
    //     '<version>1.1</version>' +
    //     '<session>' + obj.sessionId + '</session>' +
    //     '<command>friend-search</command>' +
    //     '<client>' +
    //     '<oem>' + obj.oem + '</oem>' +
    //     '<type>1</type>' +
    //     '</client>' +
    //     '</header>' +
    //     '<content>' +
    //     '<account>' + obj.account + '</account>' +
    //     '</content>' +
    //     '</envelope>';
    var xml = {
        header: {
            flag: 'tdkcloud',
            version: 1.1,
            session: obj.sessionId,
            command: 'friend-search',
            client: {
                oem: obj.oem
            }
        },
        content: {
            'account': obj.account
        }
    };
    xml = fun.objToXml(xml, 'envelope');
    xml = fun.xmlToString(xml);
    return xml;
};
//获得设备默认分享参数-权限与时段
function shareConfig(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>get-device-share-config</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//退出设备分享
function exitShareSet(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>exit-device-share</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<devices>' +
        '<count>1</count>' +
        '<device>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '</device>' +
        '</devices>' +
        '</content>' +
        '</envelope>';
    return xml;
};
//同意或拒绝好友申请
function friendApply(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>friend-audit</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<account-id>' + obj.id + '</account-id>' +
        '<approve>1</approve>' + //0---拒绝;1---同意
        '</content>' +
        '</envelope>';
    return xml;
};
//同意或者忽略被分享的设备
function acceptDevice(obj) {
    var xml = '<?xml version="1.0" encoding="utf-8"?>' +
        '<envelope>' +
        '<header>' +
        '<flag>tdkcloud</flag>' +
        '<version>1.1</version>' +
        '<session>' + obj.sessionId + '</session>' +
        '<command>share-device-audit</command>' +
        '<client>' +
        '<oem>' + obj.oem + '</oem>' +
        '<type>1</type>' +
        '</client>' +
        '</header>' +
        '<content>' +
        '<device-id>' + obj.id + '</device-id>' +
        '<share-memo>' + obj.name + '</share-memo>' + //如果为空或者没有传该字段，则使用设备名作为设备备注名
        '<share-audit>' + obj.accept + '</share-audit>' + //同意：1，忽略：0
        '<is-hs-device>' + obj.isHs + '</is-hs-device>' +
        '</content>' +
        '</envelope>';
    return xml;
};
var share = {
    getFriendList: getFriendList,
    deviceShare: deviceShare,
    deviceSharec: deviceSharec,
    deviceShareSet: deviceShareSet,
    changePower: changePower,
    changeTime: changeTime,
    cancelShareSet: cancelShareSet,
    exitShareSet: exitShareSet,
    searchFriend: searchFriend,
    friendApply: friendApply,
    acceptDevice: acceptDevice,
    shareConfig: shareConfig,
    subdevShare: subdevShare
};
export default share;


// WEBPACK FOOTER //
// ./src/assets/js/share.js